var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"rule-content"},[_c('div',{staticClass:"content",style:({
      backgroundImage: `url(${'https://website.xdcdn.net/poster/58881/2024_EventsCentre/FU027uZC.jpg'})`,
      transform: `scale(${_vm.scale})`
    }),on:{"click":function($event){return _vm.hideModal()}}},[_c('div',{staticClass:"close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }